<template>
  <Grid ref="parentGrid" v-bind="{ ...props }" @add-button-clicked="addClick" @edit-button-clicked="editClick">
    <UnitTypeAddEditForm ref="addEditRef" @submit-add-edit-form="onFormSubmit" />
  </Grid>
</template>

<script>
// Constants
import Constants from '../../constants/constants';

// Components
import Grid from '../shared/Grid.vue';

// Forms
import UnitTypeAddEditForm from './UnitTypeAddEditForm';

// Mixins
import FormMixin from '../shared/FormMixin';

export default {
  name: 'UnitTypeGrid',
  data() {
    return {
      props: {
        api: { ...Constants.Api.Endpoint.UnitType },
        columns: Constants.Grid.UnitType.columns,
        doClientSide: Constants.Grid.UnitType.doClientSide,
        filter: Constants.Grid.UnitType.filter,
        paging: Constants.Grid.UnitType.paging,
        searchHeader: Constants.Grid.UnitType.searchHeader,
        searchPlaceholder: Constants.Grid.UnitType.searchPlaceholder,
        sort: Constants.Grid.UnitType.sort,
        title: Constants.Grid.UnitType.title
      },
      columnConstants: Constants.ColumnName.UnitType,
      idField: Constants.ColumnName.UnitType.unitTypeId.field
    };
  },
  mixins: [FormMixin],
  components: {
    Grid,
    UnitTypeAddEditForm
  }
};
</script>
